"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OilTank = function OilTank(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21.21",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,2.13H10.48L11.77.83a.49.49,0,0,0,0-.69A.49.49,0,0,0,11.42,0h0a.48.48,0,0,0-.35.14L8.75,2.49A.36.36,0,0,0,9,3.11H21a2,2,0,0,1,2,2v4H1v-4a2,2,0,0,1, 2-2H4.93a.36.36,0,0,0,.25-.63L2.7.13A.49.49,0,0,0,1.87.5.48.48,0,0,0,2,.84L3.38,2.13H3a3,3,0,0,0-3,3V15.46a3,3,0,0,0,3,3H15v.83h-.57a.49.49,0,0,0,0, 1H15v.45a.49.49,0,0,0,1,0v-.44h1.1v.44a.49.49,0,0,0,1,0v-.44h.35a.49.49,0,0,0,0-1h-.35v-.83H21a3,3,0,0,0,3-3V5.15A3,3,0,0,0,21,2.13Z"
  }));
};

var _default = OilTank;
exports["default"] = _default;